const API_BASE_URL = process.env.REACT_APP_API_URL || "";

export const capitalizeFirstLetters = (
  text: string | number | undefined
): string => {
  if (typeof text === "number") throw new Error("Only strings allowed");
  if (!text || typeof text !== "string" || text.length === 0) return "";

  return text.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const getMediaUrl = (path?: string) => {
  if (!path) return "";
  // If already a full URL, return as is
  if (path.startsWith("http")) return path;
  // Otherwise, combine with API base URL
  return `${API_BASE_URL}${path.startsWith("/") ? "" : "/"}${path}`;
};
